import DeviceOwnership from './DeviceOwnership';

export * from './deviceShareCodes.reducer';
export default DeviceOwnership;
